import { render, staticRenderFns } from "./uploadReceita.vue?vue&type=template&id=ac32ebd0"
import script from "./uploadReceita.ts?vue&type=script&lang=js&external"
export * from "./uploadReceita.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac32ebd0')) {
      api.createRecord('ac32ebd0', component.options)
    } else {
      api.reload('ac32ebd0', component.options)
    }
    module.hot.accept("./uploadReceita.vue?vue&type=template&id=ac32ebd0", function () {
      api.rerender('ac32ebd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/uploadReceita.vue"
export default component.exports